export default {
  failed_to_open: 'Could not open onboarding for this restaurant. Please try again.',
};
